import resume from '../assets/pdf/resume.pdf'
import profileImg from '../assets/png/5.png'
// import profileImg from '../assets/png/forBixo.jpg'
// import profileImg from '../assets/png/forbixo2.jpg'
// import profileImg from '../assets/png/maaz.jpeg'




export const headerData = {
    name: 'Maaz Haider',
    title: "Software Engineer",
    desciption: "Life may be a meandering path but don't worry about it, rather enjoy it. It is about the journey, not the destination so explore all that comes your way, learn and grow from it, for this journey only happens once.",
    image: profileImg,
    resumePdf: resume
}
